// removed by extract-text-webpack-plugin
module.exports = {"table":"vlzu4j_OS8ZUcvBsd5DV-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalAddressManager/PersonalAddressManager.scss
 ** module id = 1083
 ** module chunks = 0
 **/